import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { EndpointBase } from './endpoint-base.service';
import { ConfigurationService } from './configuration.service';
import { Competence } from '../models/competence.model';


@Injectable()
export class CompetencesEndpoint extends EndpointBase {

  constructor(private configurations: ConfigurationService, http: HttpClient, authService: AuthService) {
    super(http, authService);
  }

  createCompetenceEndpoint<T>(comp: Competence): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/competence`;

    return this.http.post<T>(endpointUrl, JSON.stringify(comp), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.createCompetenceEndpoint(comp));
      }));
  }

  updateCompetenceEndpoint<T>(id: number, comp: Competence): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/competence/${comp.competenceId}`;

    return this.http.put<T>(endpointUrl, JSON.stringify(comp), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateCompetenceEndpoint(id, comp));
      }));
  }

  deleteCompetenceEndpoint<T>(id: number): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/competence/${id}`;

    return this.http.delete<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.deleteCompetenceEndpoint(id));
      }));
  }

  competenceExistEndpoint<T>(code: string): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/competence/code/${code}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.competenceExistEndpoint(code));
      }));
  }

  numeroCompetenceExistEndpoint<T>(params: string[]): any {
    const endpointUrl = `${this.configurations.baseUrl}/api/competence/numeroCompetence`;
    
    return this.http.post<T>(endpointUrl, JSON.stringify(params), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.numeroCompetenceExistEndpoint(params));
      }));
  }

}
